/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { createContext } from 'react';
export const PipelineStateContext = createContext(
// this will always be defined
undefined);